import { gql } from "@gygadmin/client3";

export const SupplierEmailAction = gql`
  mutation supplierEmailAction($input: SupplierEmailInput!) {
    supplierEmailAction(input: $input)
  }
`;
